/* eslint-disable no-restricted-syntax */
import {
  GET_MY_LEAVES,
  GET_MANAGEMENT_LEAVES,
  POST_LEAVE,
  PATCH_LEAVE,
  LEAVE_LOADING,
  LEAVE_ERROR,
  CANCEL_LEAVE,
} from '../actions/types';
import { ActionReducer } from '../types';
import { ILeave } from '../types/leave';

interface LeaveState {
  leaves: ILeave[],
  managementLeaves: ILeave[],
  isLoading: string[],
  error: string | null,
}

const DEFAULT_STATE: LeaveState = {
  leaves: [],
  managementLeaves: [],
  isLoading: [],
  error: null,
};

// eslint-disable-next-line default-param-last
const leaveReducer = (state = DEFAULT_STATE, action: ActionReducer) => {
  let updatedState = {};
  const { leaves, managementLeaves } = state;
  switch (action.type) {
    case GET_MY_LEAVES:
      updatedState = {
        ...state,
        leaves: action.payload,
        isLoading: state.isLoading.filter((d) => d !== action.type),
      };
      break;
    case GET_MANAGEMENT_LEAVES:
      updatedState = {
        ...state,
        managementLeaves: action.payload,
        isLoading: state.isLoading.filter((d) => d !== action.type),
      };
      break;
    case POST_LEAVE:
      updatedState = {
        ...state,
        leaves: [action.payload, ...leaves],
        isLoading: state.isLoading.filter((d) => d !== action.type),
      };
      break;
    case PATCH_LEAVE: {
      const patchLeave = action.payload;
      updatedState = {
        ...state,
        managementLeaves: managementLeaves.map((l) => (
          l._id === patchLeave?._id ? patchLeave : l
        )),
        leaves: leaves.map((l) => (
          l._id === patchLeave?._id ? patchLeave : l
        )),
        isLoading: state.isLoading.filter((d) => d !== action.type),
      };
      break;
    }
    case CANCEL_LEAVE:
      updatedState = {
        ...state,
        leaves: leaves.map((l) => (l._id === action.payload?._id ? action.payload : l)),
        isLoading: state.isLoading.filter((d) => d !== action.type),
      };
      break;
    case LEAVE_LOADING:
      updatedState = {
        ...state,
        isLoading: [...state.isLoading, action.payload],
      };
      break;
    case LEAVE_ERROR:
      updatedState = { ...state, error: action.payload || null };
      break;
    default:
      updatedState = { ...state };
      break;
  }
  return updatedState;
};

export default leaveReducer;
